export var RequestMethods;
(function (RequestMethods) {
    RequestMethods["GET"] = "GET";
    RequestMethods["POST"] = "POST";
})(RequestMethods || (RequestMethods = {}));
export var RequestUrl;
(function (RequestUrl) {
    RequestUrl["REQUEST_LOYALTY_URL"] = "/system/ajax/ShoppingBag/AddToShoppingBagItemAndCheckLoyalty";
    RequestUrl["REQUEST_ADD_TO_BASKET_FOR_MONEY"] = "/system/ajax/ShoppingBag/AddOrUpdateShoppingBagItem";
    RequestUrl["REQUEST_ADD_BASKET_OFFER"] = "/system/ajax/Offer/ApplyBasketOffer";
    RequestUrl["REQUEST_PURCHASE_BASKET_OFFER"] = "/system/ajax/Offer/PurchaseBasketOffer";
    RequestUrl["REQUEST_ADD_TO_BASKET_FOR_POINTS"] = "/system/ajax/Offer/AddOfferItem";
    RequestUrl["REQUEST_ADD_TO_BASKET_FOR_POINTS_FROM_REWARD_SHOP_PAGE"] = "/system/ajax/Offer/RedeemLoyaltyPoints";
    RequestUrl["REMOVE_BASKET_URL"] = "/system/ajax/ShoppingBag/RemoveShoppingBagItem";
    RequestUrl["UPDATE_BASKET_ITEM_URL"] = "/system/ajax/ShoppingBag/UpdateShoppingBagItem";
    RequestUrl["REQUEST_SHOPPING_CONTEXT"] = "/system/ajax/ShoppingBag/GetShoppingContext";
    RequestUrl["REQUEST_CLEAR_BASKET"] = "/system/ajax/ShoppingBag/RemoveAllShoppingBagItems";
    RequestUrl["REQUEST_ADD_CUSTOMER_ORDER"] = "/system/ajax/EndConsumerOrder/ApproveOrders";
    RequestUrl["REQUEST_REMOVE_CUSTOMER_ORDER"] = "/system/ajax/EndConsumerOrder/UnapproveOrder";
    RequestUrl["REQUEST_UPDATE_CUSTOMER_ORDER_ITEM"] = "/system/ajax/EndConsumerOrder/UpdateEndConsumerOrderItem";
    RequestUrl["REQUEST_UPDATE_OFFER_ITEMS"] = "/system/ajax/Offer/UpdateOfferItems";
    RequestUrl["REQUEST_RESET_SHIPPING_SELECTION"] = "/system/ajax/Delivery/ResetFreeShippingSelection";
    RequestUrl["REQUEST_ADD_VOUCHER"] = "/system/ajax/ShoppingBag/AddVoucher";
    RequestUrl["REQUEST_REMOVE_VOUCHER"] = "/system/ajax/ShoppingBag/RemoveVoucher";
    RequestUrl["REQUEST_DELAY_SUBSCRIPTION"] = "/system/ajax/ShoppingBag/DelaySubscription";
    RequestUrl["REQUEST_ADD_BACKORDER_DEMAND"] = "/system/ajax/ShoppingBag/AddBackorderDemand";
    RequestUrl["REQUEST_CANCEL_BACKORDER_DEMAND"] = "/system/ajax/ShoppingBag/CancelBackorderDemand";
    RequestUrl["REQUEST_REPLACE_SHOPPING_BAG_ITEM"] = "/system/ajax/ShoppingBag/ReplaceShoppingBagItem";
    RequestUrl["REQUEST_UPDATE_OFFER_ITEM"] = "/system/ajax/Offer/UpdateOfferItem";
})(RequestUrl || (RequestUrl = {}));
